import { styled } from '@/src/stitches.config'

export const HalfFieldsWrapper = styled('div', {
    display: 'flex',
    fd: 'column',
    '@media (min-width:450px)': {
        jc: 'space-between',
        fd: 'row',
    },
})

export const ApplicationStatusText = styled('p', {
    lineHeight: 1.75,
    width: 500,
    maxWidth: '100%',
    '& a': {
        textDecoration: 'underline',
        color: '$primary',
        fontWeight: 'bold',
    },
    '@sm': {
        fontSize: '1.15rem',
    },
})

export const BackButton = styled('div', {
    display: 'inline-block',
    cursor: 'pointer',
    '&:hover': {
        color: '$primary',
        textDecoration: 'underline',
    },
    variants: {
        position: {
            absolute: {
                position: 'absolute',
                top: 25,
                left: 0,
            },
            static: {
                position: 'static',
                mb: 10,
                marginTop: 15,
            },
        },
    },
    defaultVariants: {
        position: 'absolute',
    },
})

export const LoadingText = styled('div', {
    display: 'flex',
    ai: 'center',
    gap: 15,
    '& p': {
        color: '$dark',
        mb: 15,
    },
})

export const CartEmptyContainer = styled('div', {
    margin: '10% auto',
    pt: '10%',
    maxWidth: '92%',
    alignItems: 'center',
    textAlign: 'center',
    '& h2': {
        pb: 20,
    },
    '@sm': {
        pt: 0,
    },
})
